/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

// Create a observer to detect DOM changes, and replaces unintended <style> tag inserted by mintlify chat widget.
export const replaceMintlifyWidgetInjectedStyles = async () => {
  const { default: styles } = await import('./docs-widget.css?raw');

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node instanceof Element &&
          node.tagName === 'STYLE' &&
          node.textContent?.includes('mintlify-prose')
        ) {
          node.textContent = styles;
        }
      });
    });
  }).observe(document.head, { childList: true, subtree: true });
};
